import { ReactElement } from 'react';
import { NavLink } from '@localstack/ui';
import { buildRoute } from '@localstack/services';

import { LambdaRoutes } from '../../types';

interface NavTabsProps {
  routes: LambdaRoutes;
}

export const NavTabs = ({ routes }: NavTabsProps): ReactElement => {
  return (
    <>
      <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_FUNCTIONS)} end>
        Event Functions
      </NavLink>
      <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_WEB_FUNCTIONS)} end isNew>
        Web Functions
      </NavLink>
      <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_LAYERS)} pro>
        Layers
      </NavLink>
      <NavLink to={buildRoute(routes.RESOURCES_LAMBDA_CAPACITY_PROVIDERS)} pro>
        Capacity Providers
      </NavLink>
    </>
  );
};
